module.exports = __webpack_public_path__ + "static/media/kisan_hin.99a1d9ef.png";